import React, { useState, useEffect } from "react"
import { Select as SelectBase } from "@stardust-ds/react"

import Label from "../Label"
import styles from "./index.module.scss"
import MoveEllipsisIcon from "../../../assets/icons/MoveEllipsisIcon"

const Select = React.forwardRef((props, ref) => {
  const {
    label,
    defaultValue,
    onSelect,
    multiSelect,
    bIsDraggable,
    bIsDisabled,
    className,
    ...oRest
  } = props

  const [aDefaultValues, fnSetADefaultValues] = useState(defaultValue)

  useEffect(() => {
    fnSetADefaultValues(defaultValue)
  }, [defaultValue])

  function fnHandleOnClear() {
    onSelect?.([])
    fnSetADefaultValues([])
  }

  function fnHandleOnSelect(e) {
    onSelect?.(e)
    if (multiSelect) return

    // close options when selecting an item
    setTimeout(() => {
      document.body?.lastChild?.click()
    }, 10)

  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      event.stopPropagation()
      event.preventDefault()
    }
  }
  function fnHandleCloseOptions(e) {
    handleKeyDown(e)
    if (!multiSelect) return
    
    // close options when pressing tab
    if (e.keyCode === 9 && document?.body?.lastChild) {
      document.body.lastChild?.click()
    }
  }

  const bHasSelectedLabel = label?.lenght
    ? label?.includes("(Deve ser selecionado")
    : false
  const cLabels = bHasSelectedLabel ? label?.split(" (") : ""

  const text = bHasSelectedLabel ? (
    <label className={styles.label}>
      {cLabels?.label1}
      <span style={{ color: "#737D86" }}> ({cLabels?.label2}</span>
    </label>
  ) : (
    label
  )

  return (
    <div
      className={`${styles.selectContainer} ${className}`}
      onKeyDown={fnHandleCloseOptions}
    >
      {bIsDraggable ? (
        <div className={styles.draggableComponent}>
          <MoveEllipsisIcon />
          <Label className={styles.label}>{label}</Label>
        </div>
      ) : (
        <Label className={styles.label}>{text}</Label>
      )}

      <SelectBase
        id="select"
        ref={ref}
        defaultValue={aDefaultValues}
        onSelect={fnHandleOnSelect}
        onClear={fnHandleOnClear}
        multiSelect={multiSelect}
        disabled={bIsDisabled}
        searchable={true}
        onKeyDown={handleKeyDown}
        autoComplete="off"
        {...oRest}
      />
    </div>
  )
})

Select.displayName = "Select"

export default Select
